// Product List Footer Arrows - Connect to carousel
document.addEventListener('DOMContentLoaded', function() {
  const footerArrows = document.querySelector('[data-carousel-footer-arrows]');
  if (!footerArrows) return;

  // Find the carousel in the same section
  const section = footerArrows.closest('.section-resource-list');
  if (!section) return;

  const carousel = section.querySelector('.resource-list__carousel slideshow-component');
  if (!carousel) return;

  // Handle arrow clicks - slideshow-arrow uses class names for action
  footerArrows.addEventListener('click', function(e) {
    const button = e.target.closest('.slideshow-control');
    if (!button) return;

    if (button.classList.contains('slideshow-control--previous')) {
      carousel.previous();
    } else if (button.classList.contains('slideshow-control--next')) {
      carousel.next();
    }
  });

  // Update disabled state of arrows based on carousel position
  function updateArrowStates() {
    const previousBtn = footerArrows.querySelector('.slideshow-control--previous');
    const nextBtn = footerArrows.querySelector('.slideshow-control--next');

    if (!carousel.infinite) {
      const currentIndex = carousel.current || 0;
      const slides = carousel.querySelectorAll('slideshow-slide');

      if (previousBtn) {
        previousBtn.disabled = currentIndex === 0;
      }

      if (nextBtn) {
        nextBtn.disabled = currentIndex >= slides.length - 1;
      }
    }
  }

  // Listen for carousel changes
  carousel.addEventListener('slideshow:select', updateArrowStates);

  // Initial state
  updateArrowStates();
});